import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-1"
}
const _hoisted_2 = {
  id: "new-password-success-message",
  class: "text-4xl text-green-600 font-bold text-center w-full mb-20"
}
const _hoisted_3 = {
  key: 1,
  class: "p-1"
}
const _hoisted_4 = {
  id: "new-password-error-message",
  class: "text-2xl text-red-600 font-bold text-center w-full mb-20"
}
const _hoisted_5 = {
  key: 2,
  class: "w-full"
}
const _hoisted_6 = { class: "mb-6 mt-6 md:flex md:flex-row" }
const _hoisted_7 = { class: "mb-4 md:w-1/3" }
const _hoisted_8 = { class: "text-regular text-black" }
const _hoisted_9 = { class: "md:w-3/6" }
const _hoisted_10 = { class: "mb-6 mt-6 md:flex md:flex-row" }
const _hoisted_11 = { class: "mb-4 md:w-1/3" }
const _hoisted_12 = { class: "text-regular text-black" }
const _hoisted_13 = { class: "md:w-3/6" }
const _hoisted_14 = {
  key: 0,
  class: "mb-6 mt-6 md:flex-row"
}
const _hoisted_15 = {
  key: 0,
  id: "new-password-repeat-error",
  class: "text-red-600 font-bold text-center w-full"
}
const _hoisted_16 = {
  key: 1,
  id: "new-password-length-error",
  class: "text-red-600 font-bold text-center w-full"
}
const _hoisted_17 = { class: "md:flex md:flex-row md:justify-center md:mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_input = _resolveComponent("default-input")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.finished)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("account.settings.new_password.general_success")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.finished === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("account.settings.new_password.general_error")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.finished === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("account.settings.new_password.input")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_default_input, {
                type: "password",
                id: "new-password",
                modelValue: _ctx.newPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("account.settings.new_password.repeat_input")), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_default_input, {
                type: "password",
                id: "new-password-repeat",
                modelValue: _ctx.newPasswordRepeat,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPasswordRepeat) = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"])
            ])
          ]),
          (!_ctx.validPassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.passwordsRepeated)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("account.settings.new_password.repeat_error")), 1))
                  : _createCommentVNode("", true),
                (!_ctx.correctLength)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("account.settings.new_password.length_error")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_default_button, {
              type: "outline",
              class: "w-full mb-2 md:w-auto",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_default_button, {
              class: "w-full md:w-auto md:ml-4",
              onClick: _ctx.changePassword,
              disabled: !_ctx.validPassword || !_ctx.newPassword || !_ctx.newPasswordRepeat,
              "is-loading": _ctx.isLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("account.settings.change_password")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "is-loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}